<template>
  <div id="total_info">
    <div class="total_info-power">
      <div class="total_info-power-title">{{locale('Total Power','实时总负荷')}}<br/>（MW）</div>
      <div class="total_info-power-content">{{totalPower}}</div>
    </div>
    <div class="total_info-factory">
      <div class="total_info-factory-title">{{locale('Global Plants','全球工厂')}}<br/>{{locale('(Site)','（家）')}}</div>
      <div class="total_info-factory-content">158</div>
    </div>
    <div class="total_info-factory">
      <div class="total_info-factory-title">{{locale('Online Plants','在线工厂')}}<br/>{{locale('(Site)','（家）')}}</div>
      <div class="total_info-factory-content">{{linPlan}}</div>
    </div>

  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'WaterLevelChart',
  data() {
    return {
      totalPower: '',
      refreshTimer: '',
      queryParams: '',
      linPlan: ''
    };
  },
  mounted() {
    const { refreshData } = this;

    refreshData()

    // this.timer = setInterval(this.refreshData, 1000 * 60)
  },
  methods: {
    refreshData(value) {
      console.log("KW!!!!!!!!!")
      this.queryParams = {}
      if (value === undefined) {
        value = this.queryParams
      } else {
        this.queryParams = value
      }
      request({
        url: 'Kanban/GetOnlinPlanAndKw',
       // url: 'Kanban/RealPowerFromRedis',
        method: 'post',
        data: this.queryParams
      }).then(response => {
        const res = response
        console.log(res)
        this.totalPower = res.data.sumKw
        this.linPlan = res.data.PlancCunt
      })
    }
  }
};
</script>

<style lang="less" scoped>
#total_info {
  width: 100%;
  box-sizing: border-box;
  margin-left: 50px;
  background-color: #17293d;
  display: flex;
  flex-direction: column;

  .total_info-power {
    margin-top: 10px;
    margin-bottom: 40px;
    border-left: 3px solid #75E35E;
    border-top: 0px solid #75E35E;
    height: 40%;
  }
  .total_info-power-title {
    font-weight: bold;
    height: 50px;
    display: flex;
    align-items: left;
    font-size: 20px;
    justify-content: left;
    margin-top: 10px;
    margin-left: 10px;
    color: #dadada;
  }
  .total_info-power-content {
    font-weight: bold;
    height: 50px;
    display: flex;
    align-items: left;
    font-size: 50px;
    justify-content: left;
    margin-left: 10px;
    padding-top: 20px;
    padding-bottom: 10px;
    color: #75E35E;
  }

  .total_info-factory {
    margin-top: 20px;
    margin-bottom: 30px;
    border-left: 3px solid #FCAE63;
    border-top: 0px solid #FCAE63;
    height: 30%;
  }
  .total_info-factory-title {
    font-weight: bold;
    height: 50px;
    display: flex;
    align-items: left;
    font-size: 20px;
    justify-content: left;
    margin-top: 10px;
    margin-left: 10px;
    color: #dadada;
  }
  .total_info-factory-content {
    font-weight: bold;
    height: 50px;
    display: flex;
    align-items: left;
    font-size: 40px;
    justify-content: left;
    margin-left: 10px;
    padding-top: 20px;
    padding-bottom: 10px;
    color: #FCAE63;
  }

}
</style>
